export default __webpack_public_path__ + "static/media/twitter-icon.c2226dc6.svg";